module.exports = __webpack_public_path__ + "img/embodied.2a656888.png";